import '@babel/polyfill';
//import 'babel-loader';

import Vue from 'vue';
import App from './App.vue';
import './plugins/filter';
import router from './plugins/router';
import bootstrapvue from './plugins/bootstrap';
import vuelidation from './plugins/vuelidation';
import axios from './plugins/axios';
import store from './plugins/vuex';
import veevalidate from './plugins/VeeValidate';
import toasted from './plugins/Toasted';

Vue.config.productionTip = false;

new Vue({
	store,
	router,
	veevalidate,
	bootstrapvue,
	toasted,
	vuelidation,
	axios,
	render: h => h(App)
}).$mount('#app');

// todo: write into header and footer
// header: <script src="//assets.adobedtm.com/fc2dcaca336532c4b5111f69245b1e462696e4c9/satelliteLib-51cfa0fdc3fe7a91714955a46fcb494a602c58f2.js"></script>
// footer: <script type="text/javascript">_satellite.pageBottom();</script>